import styled from 'astroturf/react';
import { Link } from 'react-router-dom';

const Breadcrumbs = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`;

const Breadcrumb = styled(Link)`
  padding: 10px 18px 10px 16px;
  font-size: var(--ph-heading-two);
  font-family: var(--ph-font-family-lato-regular);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: var(--black);
  position: relative;
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  & + & {
    padding-left: 21px;

    &::before {
      content: '';
      position: absolute;
      left: -2px;
      top: 30px;
      border: solid var(--ph-light-blue-500);
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(-45deg);
    }
  }

  &:first-child {
    padding-left: 0;
  }

  &:hover {
    text-decoration: none;
  }
`;

export default {
  Breadcrumbs,
  Breadcrumb,
};
